import { render } from "./DeclencheurSubscribeToNewsletter.vue?vue&type=template&id=6907f55d"
import script from "./DeclencheurSubscribeToNewsletter.vue?vue&type=script&lang=ts"
export * from "./DeclencheurSubscribeToNewsletter.vue?vue&type=script&lang=ts"
script.render = render

export default script